import AppBarAdmin from "../../components/AppBarAdmin";
import Table from "../../components/Table";
import { createProjeto, deleteProjeto, getProjetos, updateProjeto } from "../../services/projetosService";

export default function Projetos() {
    return (
        <>
            <AppBarAdmin title="Projetos" />
            <Table 
                loadData={getProjetos} 
                createItem={createProjeto}
                updateItem={updateProjeto}
                deleteItem={deleteProjeto}
                titulo="Projetos" 
            />
        </>
    )
}